import { Column } from '../components/Table/types';
import { Totals } from '../types';

export const getTestResultsTotalsColumnFilterConfig = <T>({
  testResultsTotals,
  key,
}: {
  testResultsTotals: Record<string, Totals>;
  key: keyof T;
}): Partial<Column<T>> => ({
  filterable: true,
  emptyValueLabel: 'No tests',
  filterOperators: ['equals', 'notEquals'],
  filterOptionsOverride: [
    { value: 'errors', label: 'Errors' },
    { value: 'failures', label: 'Failures' },
    { value: 'passed', label: 'Passed' },
    { value: 'warnings', label: 'Warnings' },
    { value: '', label: '' },
  ],
  filterValueMatcher: (selectedFilterValue, row) => {
    const totals: Record<string, number> =
      testResultsTotals[row[key] as string];

    return selectedFilterValue.some((val) => {
      if (!val) {
        return (
          !totals ||
          (!totals?.errors &&
            !totals?.warnings &&
            !totals?.passed &&
            !totals?.failures)
        );
      }
      return totals?.[val] > 0;
    });
  },
});
